import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../components/LanguageContext";
import { ThemeContext } from "../../contexts/ThemeContext";

const Home = () => {
  const { isRTL } = useLanguage();
  const { isDarkMode } = useContext(ThemeContext);

  return (
    <div
      className={`home-container min-h-screen ${
        isDarkMode ? "bg-black text-white" : "bg-white text-black"
      }`}
    >
      <h1 className="text-4xl font-bold text-center my-8 pt-20">
        {isRTL ? "مرحبًا بكم في دار السبائك" : "Welcome to Dar Alsabaek"}
      </h1>
      <div className="flex justify-center space-x-4">
        <Link
          to="/swiss-bar"
          className="bg-yellow-600 text-white py-2 px-4 rounded hover:bg-yellow-700 transition duration-300"
        >
          {isRTL ? "استعرض السبائك السويسرية" : "Browse Swiss Bars"}
        </Link>
        {/* Add more category links as needed */}
      </div>
    </div>
  );
};

export default Home;
